export default "__VITE_ASSET__af47363a__"